import React, { useState, useEffect } from 'react'; 
import { motion } from 'framer-motion'; 
import { FaPen } from 'react-icons/fa'; 
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '../../styles/user/profileInfo.css';

const ProfilePage = React.memo(({
  profileData,
  handleProfileChange,
  handleCancelEdit,
  handleSaveProfile,
}) => {
   const navigate = useNavigate();
  const initialPhone = profileData?.phonenumber ?? '';
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [tempPhoneNumber, setTempPhoneNumber] = useState(initialPhone);
  const [phoneError, setPhoneError] = useState('');

  useEffect(() => {
    setTempPhoneNumber(profileData?.phonenumber ?? '');
  }, [profileData?.phonenumber]);

  const handlePhoneChange = (e) => {
    const onlyNumbers = e.target.value.replace(/\D/g, '').slice(0, 10);
    setTempPhoneNumber(onlyNumbers);

    if (onlyNumbers.length === 0) {
      setPhoneError('Phone number is required.');
    } else if (onlyNumbers.startsWith('0')) {
      setPhoneError('Phone number should not start with 0.');
    } else if (onlyNumbers.length < 10) {
      setPhoneError('Phone number must be 10 digits.');
    } else {
      setPhoneError('');
    }
  };

  const cancelEdit = () => {
    setTempPhoneNumber(profileData?.phonenumber ?? '');
    setPhoneError('');
    setIsEditingPhone(false);
    handleCancelEdit();
  };

  const updatePhone = () => {
    if (
      !tempPhoneNumber ||
      tempPhoneNumber.length !== 10 ||
      tempPhoneNumber.startsWith('0')
    ) {
      setPhoneError('Enter a valid 10-digit phone number (should not start with 0).');
      return;
    }

    // ✅ IMPORTANT FIX: pass value directly
    handleSaveProfile(tempPhoneNumber);

    setIsEditingPhone(false);
    setPhoneError('');
  };

  return ( 
  <motion.div 
    className="profile-wrapper" 
    initial={{ opacity: 0, y: 50 }} 
    animate={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.5, ease: 'easeOut' }} 
  >

    {/* Back Button */}
    <div className="profile-back-wrapper">
      <button
        type="button"
        className="profile-back-button"
        onClick={() => navigate(-1)}
      >
        <ArrowLeft size={18} />
        <span>Back</span>
      </button>
    </div>

    <div className="profile-header">Profile Information</div>

      <div className="profile-card">
        <div className="info-group">
          <label>Name:</label>
          <p>{profileData.username}</p>
        </div>

        <div className="info-group">
          <label>Company Name:</label>
          <p>{profileData.companyname}</p>
        </div>

        <div className="info-group">
          <label>Email Id:</label>
          <p>{profileData.personalemail}</p>
        </div>

        <div className="form-group info-group">
          <label>Phone Number:</label>

          {isEditingPhone ? (
            <>
              <input
                type="text"
                name="phonenumber"
                inputMode="numeric"
                pattern="\d*"
                maxLength={10}
                value={tempPhoneNumber}
                onChange={handlePhoneChange}
                aria-describedby="phone-help"
              />

              <div id="phone-help" className="field-help">
                {phoneError && <span className="error-text">{phoneError}</span>}
              </div>

              <div className="form-buttons">
                <button
                  className="cancel-btn"
                  onClick={cancelEdit}
                  type="button"
                >
                  Cancel
                </button>

                <button
                  className="save-btn"
                  onClick={updatePhone}
                  type="button"
                  disabled={
                    tempPhoneNumber.length !== 10 ||
                    tempPhoneNumber.startsWith('0')
                  }
                  aria-disabled={
                    tempPhoneNumber.length !== 10 ||
                    tempPhoneNumber.startsWith('0')
                  }
                >
                  Update
                </button>
              </div>
            </>
          ) : (
            <div className="phone-display">
              <span>{profileData.phonenumber || '-'}</span>
              <FaPen
                className="edit-pen-icon"
                onClick={() => {
                  setTempPhoneNumber(profileData?.phonenumber ?? '');
                  setPhoneError('');
                  setIsEditingPhone(true);
                }}
              />
            </div>
          )}
        </div>
      </div>
    </motion.div>
  );
});

export default ProfilePage;
